import types from './types'

export default {
    [types.SET_VALIDATION_MESSAGES](state, validationMessages) {
        state.validationMessages = [...new Map([...state.validationMessages, ...validationMessages].map(x => [x.id, x])).values()]
    },
    [types.SET_SELECTED_REPORT_TYPE](state, reportType) {
        state.reportTypeSelected = reportType
    },
    [types.SET_FILTER_TEXT_TYPE](state, text) {
        state.filterText = text
    },
}